import { render } from "./UndoRedoBtns.vue?vue&type=template&id=3360d1d3"
import script from "./UndoRedoBtns.vue?vue&type=script&lang=js"
export * from "./UndoRedoBtns.vue?vue&type=script&lang=js"

import "./UndoRedoBtns.vue?vue&type=style&index=0&id=3360d1d3&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__